// ABOUTME: React Query hook for evidence source data
// ABOUTME: Fetches interview context on demand (modal trigger)

import { useQuery } from '@tanstack/react-query'
import { evidenceApi } from '@/api/evidence'

export const useEvidenceSource = (evidenceId: string | null) => {
  return useQuery({
    queryKey: ['evidence', evidenceId],
    queryFn: () => evidenceApi.getEvidenceSource(evidenceId!),
    enabled: !!evidenceId,
    // Cache for 30 minutes (interview data is static)
    staleTime: 30 * 60 * 1000,
  })
}
